import styled, { css } from "styled-components";

const Title = styled.h1`
  margin-top: 65px;
  margin-bottom: 20px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 44px;
  text-align: center;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 28px;
      margin-bottom: 10px;
    `}
`;

export default Title;
